// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2COLS","alertIcon":"ConfirmModal_alertIcon__ceoYP"};